// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"7541466c","715":"aef6e97f"}[chunkId] + ".chunk.css";
};